/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  document.querySelectorAll("[data-sliderule-open]").forEach(function(obj) {
    obj.addEventListener("click", function(e) {
      e.preventDefault();
      var wrapper = obj.closest(".sliderule__wrapper");
      var target = "#" + obj.getAttribute("data-sliderule-open");
      //wrapper.querySelector(target).classList.add("is-open");
      wrapper.querySelector(target).classList.add("is-hiding");
    });
  });

  document.querySelectorAll(".sliderow--back").forEach(function(obj) {
    obj.addEventListener("click", function(e) {
      e.preventDefault();
      console.log("back");
      obj.closest(".sliderule__panel").classList.remove("is-open");
      obj.closest(".sliderule__panel").classList.remove("is-hiding");
    });
  });

  const header = document.querySelector('.toolbar[data-header-toolbar]');

  console.log(`founde header ::: `);
  
    window.addEventListener('scroll', function() {
      if (window.scrollY > 500 && window.innerWidth <= 768) {
        header.style.display = 'none';
      } else {
        header.style.display = 'block';
      }
    });
  

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();

